var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.022,
    height: 15.509,
    viewBox: "0 0 16.022 15.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_tag-user",
    "data-name": "vuesax/bold/tag-user",
    transform: "translate(-556 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-user",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H15.5V15.5H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M11.685,0H2.337A2.319,2.319,0,0,0,0,2.3v8.461a2.325,2.325,0,0,0,2.337,2.311h.592a2.346,2.346,0,0,1,1.651.675l1.332,1.311a1.571,1.571,0,0,0,2.2,0L9.441,13.75a2.346,2.346,0,0,1,1.651-.675h.592a2.325,2.325,0,0,0,2.337-2.311V2.3A2.319,2.319,0,0,0,11.685,0ZM7.011,2.753a1.513,1.513,0,0,1,.055,3.025H6.949A1.512,1.512,0,0,1,5.484,4.265,1.529,1.529,0,0,1,7.011,2.753ZM9.153,9.842a4.2,4.2,0,0,1-4.284,0,1.4,1.4,0,0,1,0-2.5,4.2,4.2,0,0,1,4.284,0A1.4,1.4,0,0,1,9.153,9.842Z",
    transform: "translate(2 0)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStudents);
export default __webpack_public_path__ + "static/media/sidebar-students.f44dc1648203a3d15aad33836131ce94.svg";
export { ForwardRef as ReactComponent };